import axios from "axios";
import {API} from "../config";

const path = "/servico-acolhimento";
const subPath = "/rede-referencia"

class RedeReferenciaSAService {
  novaRedeReferenciaSA(redeReferenciaSA){
    return axios.post(API + subPath, redeReferenciaSA);
  }

  getRedeReferenciaSA(id){
    return axios.get(API + subPath + path + `/${id}`)
  }

  atualizarRedeReferenciaSA(id, redeReferenciaSA){
    return axios.put(API + subPath + `/${id}`, redeReferenciaSA);
  }

  listarConselhosTutelares(){
    return axios.get(API +`/conselho-tutelar`);
  }

  listarCREAS(){
    return axios.get(API +`/creas`);
  }

  listarCRAS(){
    return axios.get(API +`/cras`);
  }

  listarSecretariasMunicipais(){
    return axios.get(API +`/secretaria-municipal`);
  }

  listarDiretoriasRegionais(){
    return axios.get(API +`/diretoria-regional`);
  }

  listarCoordenadorias(){
    return axios.get(API +`/coordenadoria-regional`);
  }
}

const instanceRedeReferenciaSA= new RedeReferenciaSAService();
export default instanceRedeReferenciaSA;